import axios from "axios";
import config from "../config";
import { getToken } from "../utils/tokenUtils";

const apiurl = config.API_URL;

export const getSearchResults = async (queryToSend, page) => {
  console.log("Search API URL:", `${apiurl}/api/v1/user/global-search?${queryToSend}&page=${page}`);
  try {
    const response = await axios.get(
      `${apiurl}/api/v1/user/global-search?${queryToSend}&page=${page}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );

    console.log("Search API Response:", response.data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getSearchHistory = async (keyword, data) => {
  try {
    const response = await axios.put(
      `${apiurl}/api/v1/user/global-search/keyword-list/${keyword}`,
      { data },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteSearchHistory = async (id) => {
  console.log("Delete search history data:", id);
  try {
    const response = await axios.put(
      `${apiurl}/api/v1/user/global-search/keyword-list/`,
      { keyword_id: id },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};

// link preview api/v1/metadata?url=${url}
export const getLinkPreview = async (url) => {
  try {
    const response = await axios.get(
      `${apiurl}/api/v1/metadata?url=${encodeURIComponent(url)}`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return response.data;
  } catch (error) {
    throw error;
  }
};


